export default function share() {
  const shareButtons = document.querySelectorAll("[data-native-share]");
  for (let i = 0; i < shareButtons.length; i += 1) {
    if (navigator.canShare) {
      shareButtons[i].addEventListener("click", function shareButtonClick(ev) {
        ev.preventDefault();
        const shareData = {
          title: document.title,
          url: ev.target.href,
        };
        navigator
          .share(shareData)
          .then(() => console.log("Shared successfully"))
          .catch((err) => console.error("Failed to share:", err));
      });
    }
  }
}
